export default __webpack_public_path__ + "static/media/our-team.2f366138.jpg";